<template>
  <div class="clearfix main_center" v-loading.fullscreen.lock="loading" >
    <div class="right-content clearfix" style="border: 1px solid #ebeef5;padding: 24px;background: #FFF;">
      <div v-if="showPdfFlag">
        <iframe  :src="pdfViewer + form.filePath " frameborder="0" width="100%" :height="cardHight" @contextmenu.prevent=""></iframe>
      </div>
      <div v-else :style="{'height':cardHight}">
        <emptyInfo :emptyMsg="'暂无见证数据'" ></emptyInfo>
      </div>
    </div>

    <div class="left-content">
      <div class="left-navbar">
        <el-button type="primary" plain size="small" style="margin-right:10px;" @click="processSubmit()" >提交</el-button>
        <el-button @click="back()"  size="small" style="margin-left:0;">返回</el-button>
      </div>
    </div>

  </div>
</template>


<script>
  import emptyInfo from '@/components/empty-info';
  import {tabsCloseCurrentHandle} from '@/utils/routeTab';

  export default {
  components: {
    emptyInfo
  },
  data(){
    return{
      cardHight:(document.documentElement.clientHeight -173) + 'px',
      pdfViewer:'/pdf/web/viewer.html?file=',
      id:'',
      showPdfFlag:false,
      loading:false,
      form:{
        id:'',
        filePath:'',
        cateoutQuest:{
          id:'',
          processinstanceid:'',
        }
      },
      variables:{
        commit:true,
        opinion:''
      }

    }
  },
    created() {
      this.pdfViewer = this.$http.adornUrl(this.pdfViewer);
    },

    activated(){

    this.id = (this.$route.query && this.$route.query.id) || (this.$route.params && this.$route.params.id) || '';
    this.getDataById();

  },
  computed: {

  },
  methods:{
    // 返回
    back(){
      tabsCloseCurrentHandle();
      this.$router.push({
        name:'cateout_quest_detail',
        query:{
          id:this.id
        }
      })
    },

    getDataById(){ //详情

      if (this.id) {

        // 查询基本信息及流程id
        this.$http.get('/cateQuestBase/get?id=' + this.id).then(res => {
          if (res.data.code === '1') {
            const data = res.data.data;
            this.form = {...data};
            this.form.filePath = (data.attachments && data.attachments[0] && data.attachments[0].filePath ) || '';
            if(this.form.filePath == ''){
              this.showPdfFlag  = false;
              //制作生成见证书pdf
              this.makePdf();
            }else{
              this.showPdfFlag  = true;
            }

          }
        })

      } else {
        this.$router.push({
          name: 'home'
        })
      }

    },


    //提交流程
    processSubmit(){
     // console.log("this.form.cateoutQuest.id==>"+this.form.cateoutQuest.id)
      this.$http.post('/cateOutQuest/processSubmit',{
        id:this.form.cateoutQuest.id,
        taskId:'',
        processinstanceid:this.form.cateoutQuest.processinstanceid,
        variables:{
          commit:true
        }
      }).then(res=>{

        if(res.data.code ==1){
          this.$message({
            type:'success',
            message:'操作成功。'
          })

          this.$router.push({
            name:'download_catequest_note',
            query:{
              id:this.id
            }
          })

        }else{
          this.$message({
            type:'error',
            message:'流程提交失败。'
          })
        }

      })
    },



    //制作生成见证书pdf
    makePdf(){

      if (this.id) {
        this.loading = true;
        this.$http.get('/cateQuestPDF/makePdf?id=' + this.id)
            .then(res => {
              if (res.data.code == '1') {
                this.loading = false;
                this.form.filePath = res.data.data;
                this.showPdfFlag = true;
                this.$message({
                  type: 'success',
                  message: res.data.msg
                })
              } else {
                this.loading = false;
                this.showPdfFlag = false;
                this.$message({
                  type: 'error',
                  message: res.data.msg
                })
              }
            }).catch(e => {
              this.loading = false;
              console.log(e)
              this.$message({
                type: 'error',
                message: '制作PDF失败'
              })

        })
      }

    },



  }



}
</script>

<style lang="less" scope>

.bidFileList {
  width: 100%;
  border: 1px solid #ebeef5;
  border-spacing: 0;
  border-collapse: collapse;
  text-align: center;

  th {
    border: 1px solid #ebeef5;
    height: 40px;
  }

  td {
    border: 1px solid #ebeef5;
    height: 30px;
  }
}


</style>